import React from "react";
import FooterDash from "../components/FooterDash";
import NavbarDash from "../components/NavbarDash";
import Sidebar from "../components/Sidebar";

const LayoutDashboard = (props) => {
  return (
    <React.Fragment>
      <main className="bg-gray-100 dark:bg-gray-800 h-auto overflow-hidden relative">
        <div className="flex items-start justify-between">
          <Sidebar />
          <div className="flex flex-col w-full pl-0 md:p-4 md:space-y-4">
            <NavbarDash />
            {props.children}
          </div>
        </div>
        <FooterDash />
      </main>
    </React.Fragment>
  );
};

export default LayoutDashboard;
